import { useFormContext } from "react-hook-form";

import { LoadingButton } from "./LoadingButton";

export const FormSubmitButton = ({
  type = "submit",
  children,
  isLoading,
  ...rest
}: React.ComponentProps<typeof LoadingButton>) => {
  const {
    formState: { isSubmitting },
  } = useFormContext();

  return (
    <LoadingButton
      type="submit"
      isLoading={isSubmitting || isLoading}
      {...rest}
    >
      {children}
    </LoadingButton>
  );
};
